import VehicleList from '../components/VehicleList';

function UpfitterPortalPage() {

  return (
      <VehicleList
        upfitterMode={true}
      />
  );
}

export default UpfitterPortalPage;

